import request from "@/plugins/axios"

//退出
export const logout=(data)=>{
  return request({
    url:"/api/oauth/AstLogout",
    method:"GET",
    })
};

//获取当前用户信息
export const getUserInfo=(data)=>{
  return request({
    url: '/api/oauth/CurrentUser',
    method:"GET",
    })
};


